import { OPM } from '~types/index'

const onOPMTurnOff = ({
  turnOff,
  setOPM,
  OPM,
}: {
  turnOff: boolean
  setOPM: (OPM: OPM) => void
  OPM: OPM
}) => {
  if (turnOff) {
    setOPM({ ...OPM, valid: false, init: false })
  }
}

export default onOPMTurnOff
